export function getDateFromString(dataValue: string | undefined) {
  if (Object.prototype.toString.call(dataValue) === "[object Date]") {
    return dataValue as unknown as Date;
  }
  if (!dataValue || !dataValue.includes(":")) {
    return undefined;
  }
  const dateValue = new Date();
  dataValue.split(":");
  dateValue.setHours(Number(dataValue.split(":")[0]));
  dateValue.setMinutes(Number(dataValue.split(":")[1]));

  if (!dateValue.valueOf()) {
    return undefined;
  }
  return dateValue;
}
